<div class="card">
    <h4 class="m-1 card-title">Market Map</h4>
  <!-- <span class="m-1 card-content">Growth > 0: green; Growth < 0: red; Growth = 0: grey</span> -->
    <app-echart [height]="600" [option]="treeMapChartOption"></app-echart>
</div>